export interface IAffiliation {
  id: number;
  product_id: number;
  product_title: string;
  product_price: number;
  product_max_price: number;
  product_status: string;
  has_variations: boolean;
  charge_type: string;
  created_at: string;
  updated_at: string;
  affiliations_status: EStatusAffiliation;
  comission_type: string;
  comission: number;
  comission_subscription: number;
  max_comissions_subscription: string;
  max_comissions: string;
  recruitment: boolean;
  indications: number;
  product_max_comission: number;
  product_max_comission_type: string;
  differentiated_comission_type: string;
  differentiated_comission_value: number;
  has_differentiated_commission: boolean;
  product_max_comission_charge_type: string;
  producer: {
    id: number;
    name: string;
    business_name: string;
  };
}

export interface IProductAffiliation {
  id: number;
  title: string;
  recruit_commission_value: number;
  recruit_commission_type: string;
  recruit_max_sales: number;
}

export enum EStatusAffiliation {
  PENDING = 'P',
  APPROVED = 'A',
  REPROVED = 'R',
}
